<div class="card">
    <div class="p-grid p-ai-center">
        <div class="p-col-12" [ngClass]="{ 'p-md-6': config.showRoleFilter }">
            <div style="white-space: nowrap;">
                <span class="p-input-icon-left" style="display: inline-block; width: calc(100% - 3rem);">
                    <i *ngIf="!usersQH.loading" class="pi pi-search"></i>
                    <i *ngIf="usersQH.loading" class="pi pi-spin pi-spinner"></i>
                    <input
                        type="text"
                        #userSearchInput
                        pInputText
                        [(ngModel)]="usersQH.search"
                        placeholder="Search"
                        style="width: 100%;"
                    >
                </span>
                <button
                    type="button"
                    pButton
                    pRipple
                    class="p-ml-1"
                    label=""
                    icon="pi pi-times"
                    styleClass="p-button-danger"
                    (click)="clearSearch()"
                ></button>
            </div>
        </div>
        <div class="p-col-12 p-md-6" *ngIf="config.showRoleFilter">
            <app-select-roles
                [(ngModel)]="selectedRoles"
                [roles]="filteredRoles"
                (ngModelChange)="searchUsersByRole()"
            ></app-select-roles>
        </div>
    </div>

    <div class="p-d-flex p-jc-end p-mt-2" style="gap: 0.5rem;">
        <button
            *ngIf="config.showNewOpportunity"
            pButton
            (click)="openNewOpportunity()"
            label="New Opportunity"
            icon="pi pi-plus"
            styleClass="p-button-outlined p-button-success"
        ></button>
        <button
            *ngIf="config.showCreateCrew"
            pButton
            (click)="openCreateCrew()"
            label="Create Crew"
            icon="pi pi-users"
            styleClass="p-button-outlined"
        ></button>
        <ng-container *ngIf="config.showInvite">
            <button
                *hasPermission="['users.create']"
                pButton
                (click)="openInviteDialog()"
                label="Invite"
                icon="pi pi-envelope"
                styleClass="p-button-outlined"
            ></button>
        </ng-container>
        <ng-container *ngIf="config.showCreate">
            <button
                *hasPermission="['users.create']"
                pButton
                (click)="openCreateUser()"
                label="Create"
                icon="pi pi-plus"
            ></button>
        </ng-container>
    </div>

    <p-table
        [value]="users"
        [loading]="usersQH.loading"
        [showLoader]="!usersQH.mergeNextResults && !usersQH.isFirstLoad"
        breakpoint="620px"
    >
        <ng-template pTemplate="header">
            <tr>
                <th>Name</th>
                <th>Contact</th>
                <th *ngIf="config.showJobs">Recent Jobs</th>
                <th>Roles</th>
                <th style="width: 3rem"></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-user>
            <tr
                class="selectable-row"
                (appDoubleClick)="freyaHelper.openItem('user', user?.id)"
                (singleClick)="selectUser(user)"
                (auxclick)="freyaHelper.openItem('user', user?.id, true)"
            >
                <td>
                    <span class="bold-on-mobile">
                        {{user.givenName}} {{user.familyName}}
                    </span>
                </td>
                <td>
                    <div class="contact-cell">
                        <div *ngIf="user.email" class="contact-line">{{ user.email }}</div>
                        <div *ngIf="user.phone" class="contact-line">{{ user | phone }}</div>
                        <ng-container *ngIf="!user.email && !user.phone">None</ng-container>
                    </div>
                </td>
                <td *ngIf="config.showJobs">
                    <div class="jobs-cell">
                        <ng-container *ngFor="let job of (user.jobs || []).slice(0, 3); let last = last">
                            <div class="job-line">
                                <span class="job-code" (click)="freyaHelper.openItem('job', job.id); $event.stopPropagation()">{{ job.code || '—' }}</span>
                                <span class="job-stage">{{ job.stage }}</span>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="!(user.jobs || []).length">No jobs</ng-container>
                    </div>
                </td>
                <td>
                    <div class="roles-cell">
                        <ng-container *ngFor="let role of (user.roles || []).slice(0, MAX_ROLE_DISPLAY); let i = index">
                            <span class="role-chip" [style.borderLeftColor]="role.color || '#ccc'">{{ role.name }}</span>
                            <ng-container *ngIf="i < (user.roles || []).slice(0, MAX_ROLE_DISPLAY).length - 1">&nbsp;</ng-container>
                        </ng-container>
                        <ng-container *ngIf="(user.roles || []).length > MAX_ROLE_DISPLAY">
                            <span class="role-chip role-overflow">+{{ (user.roles || []).length - MAX_ROLE_DISPLAY }}</span>
                        </ng-container>
                        <ng-container *ngIf="!(user.roles || []).length">None</ng-container>
                    </div>
                </td>
                <td><span></span><app-open-link [link]="'/people/'+user.id"></app-open-link></td>
            </tr>
        </ng-template>
        <ng-template pTemplate="loadingbody">
            <ng-container *ngFor="let placeholder of userPlaceholderCount">
                <tr>
                    <td><p-skeleton height="2rem" width="100%"></p-skeleton></td>
                    <td><p-skeleton height="2rem" width="100%"></p-skeleton></td>
                    <td *ngIf="config.showJobs"><p-skeleton height="2rem" width="100%"></p-skeleton></td>
                    <td><p-skeleton height="2rem" width="100%"></p-skeleton></td>
                    <td><span></span><app-open-link [disabled]="true"></app-open-link></td>
                </tr>
            </ng-container>
        </ng-template>
        <ng-template pTemplate="emptymessage">
            <tr>
                <td [attr.colspan]="config.showJobs ? 5 : 4">
                    {{pagination.emptyMessage}}
                </td>
            </tr>
        </ng-template>
    </p-table>
    <div *ngIf="!usersQH.loading && usersQH.hasMore" class="p-text-center" (appLazyLoad)="retrieveMoreUsers()">
        <span class="freya-link-button" (click)="retrieveMoreUsers()">Load more</span>
    </div>
    <div *ngIf="!usersQH.loading && !usersQH.hasMore" class="p-text-center">
        No more users to show.
    </div>
</div>

<app-mutate-user #mutate></app-mutate-user>

<p-dialog
    header="Quick Invite"
    [(visible)]="inviteDialogVisible"
    [modal]="true"
    [style]="{ width: '400px' }"
    [dismissableMask]="true"
>
    <div class="p-fluid">
        <div class="p-field p-mb-3">
            <label>Name</label>
            <input type="text" pInputText [(ngModel)]="inviteName" placeholder="John Doe" autocomplete="nope" />
        </div>
        <div class="p-field p-mb-3">
            <label>Email or Phone</label>
            <input type="text" pInputText [(ngModel)]="inviteContact" placeholder="user@example.com or (555)-123-4567" autocomplete="nope" />
            <small *ngIf="inviteContact && !isValidContact()" class="p-error">Enter a valid email or phone number</small>
        </div>
        <div class="p-field p-mb-3">
            <label>Role</label>
            <p-multiSelect
                [options]="filteredRoles || availableRoles || []"
                [(ngModel)]="inviteSelectedRoles"
                optionLabel="name"
                defaultLabel="Select Role"
                [filter]="true"
                appendTo="body"
                display="chip"
                [virtualScroll]="true"
                [itemSize]="34"
            >
                <ng-template let-role pTemplate="item">
                    <div class="invite-role-item">
                        <div>{{ role.name }}</div>
                        <small *ngIf="role.zones?.nodes?.length" class="p-text-secondary">
                            {{ role.zones.nodes[0].name }}
                        </small>
                    </div>
                </ng-template>
            </p-multiSelect>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button
            pButton pRipple
            label="Send & Invite Another"
            icon="pi pi-user-plus"
            class="p-button-outlined"
            [disabled]="inviteLoading || !canSendInvite()"
            (click)="sendInvite(true)"
        ></button>
        <button
            pButton pRipple
            label="Send Invite"
            icon="pi pi-send"
            styleClass="p-ml-2"
            [loading]="inviteLoading"
            [disabled]="inviteLoading || !canSendInvite()"
            (click)="sendInvite()"
        ></button>
    </ng-template>
</p-dialog>